export default function isEditorActive(editorState) {
  return editorState.getSelection().hasFocus;
}
